import axios from 'axios';

const api = axios.create({
  baseURL: `/api/v1/`,
  headers: {
    'Content-Type': 'application/json',
  },
  proxy: true,
});

// Any browser call made through this direct Axios client uses the same JWT
// Bearer authentication as Redux API calls. The login endpoint still works
// without a token because no Authorization header is added when none exists.
api.interceptors.request.use((request) => {
  const token = window.localStorage.getItem('token');
  if (token) {
    request.headers = request.headers || {};
    request.headers.Authorization = `Bearer ${token}`;
  }
  return request;
});

export default api;
